import React from 'react';
import { technologies } from '../data/technologies';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

const groupIcon = {
  'Languages & Frameworks': 'code',
  Database: 'database',
  'Cloud & Infrastructure': 'cloud',
  Tools: 'tools',
};

export default function TechStack() {
  return (
    <section className="section">
      <div className="container toolbox">
        <Reveal className="toolbox__intro">
          <h2>A Modern, Multi-Stack Toolbox</h2>
          <p>We pick the right tool for the job, not the trendy one.</p>
        </Reveal>
        <div className="toolbox__grid">
          {technologies.map((g, i) => (
            <Reveal key={g.group} delay={i * 70}>
              <div className="card tech__group">
                <h3><Icon name={groupIcon[g.group]} size={20} />{g.group}</h3>
                <div className="tech__items">
                  {g.items.map((t) => (
                    <div className="tech__item" key={t}>
                      <span className="tech__mono">{t.replace(/[^A-Za-z0-9/]/g, '').slice(0, 2)}</span>
                      <span>{t}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
